module.exports = __webpack_public_path__ + "img/badger-chromagear.5084151a.png";